<template>
  <b-row>
    <b-col cols="12" v-if="loadingDetails">
      <div class="d-flex justify-content-center mb-3 m-100">
        <b-spinner style="width: 5rem; height: 5rem;" label="Loading Vehicle..."></b-spinner>
      </div>
    </b-col>
    <b-col cols="12" v-else>
      <b-row>
        <b-col cols="12" md="4" class="mt-10">
          <b-form-group
            label="Licence plate"
            :invalid-feedback="selectedVehicleErrors.plateNumber"
            :state="(typeof selectedVehicleErrors.plateNumber !== 'undefined') ? false : true"
          >
            <b-form-input
              v-model="selectedVehicle.plateNumber"
              type="text"
              required
              placeholder="XXX-XXXX-XXX"
              :state="(typeof selectedVehicleErrors.plateNumber !== 'undefined') ? false : null"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mt-10">
          <b-form-group
            label="VIN number"
            :invalid-feedback="selectedVehicleErrors.vinNumber"
            :state="(typeof selectedVehicleErrors.vinNumber !== 'undefined') ? false : true"
          >
            <b-form-input
              v-model="selectedVehicle.vinNumber"
              type="text"
              required
              placeholder="XXX-XXXX-XXX"
              :state="(typeof selectedVehicleErrors.vinNumber !== 'undefined') ? false : null"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mt-10">
          <b-form-group
            label="Car nickname"
            :invalid-feedback="selectedVehicleErrors.nickname"
            :state="(typeof selectedVehicleErrors.nickname !== 'undefined') ? false : true"
          >
            <b-form-input
              v-model="selectedVehicle.nickname"
              type="text"
              placeholder="Your cars nickname."
              :state="(typeof selectedVehicleErrors.nickname !== 'undefined') ? false : null"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group
            label="Make"
            :invalid-feedback="selectedVehicleErrors.make"
            :state="(typeof selectedVehicleErrors.make !== 'undefined') ? false : true"
          >
            <v-select
              :resetOnOptionsChange="true"
              placeholder="Search Make"
              label="make_display"
              v-model="vehicleMakeSelected"
              :options="vehicleMakes"
              :state="(typeof selectedVehicleErrors.make !== 'undefined') ? false : null"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group
            label="Model"
            :invalid-feedback="selectedVehicleErrors.model"
            :state="(typeof selectedVehicleErrors.model !== 'undefined') ? false : true"
          >
            <v-select
              :resetOnOptionsChange="true"
              placeholder="Search Model"
              label="model_name"
              v-model="vehicleModelSelected"
              :options="vehicleModels"
              :state="(typeof selectedVehicleErrors.model !== 'undefined') ? false : null"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
            >
              <template slot="no-options">Select a vehicle make.</template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group
            label="Year"
            :invalid-feedback="selectedVehicleErrors.year"
            :state="(typeof selectedVehicleErrors.year !== 'undefined') ? false : true"
          >
            <v-select
              :resetOnOptionsChange="true"
              placeholder="Select Year"
              v-model="vehicleYearSelected"
              :options="carModelYear"
              :state="(typeof selectedVehicleErrors.year !== 'undefined') ? false : null"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
            >
              <template slot="no-options">Select a vehicle model.</template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group
            label="Colour"
            :invalid-feedback="selectedVehicleErrors.colour"
            :state="(typeof selectedVehicleErrors.colour !== 'undefined') ? false : true"
          >
            <v-select
              :resetOnOptionsChange="true"
              placeholder="Choose Colour"
              v-model="vehicleColourSelected"
              :options="vehicleColours"
              :state="(typeof selectedVehicleErrors.colour !== 'undefined') ? false : null"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
            >
              <template slot="no-options">Select a vehicle year.</template>
              <template slot="selected-option" slot-scope="option">
                <div class="car-colour">
                  <span class="colour-block" :style="{'background-image': option.style}"></span>
                  <span class="colour-label">{{ option.label }}</span>
                </div>
              </template>
              <template slot="option" slot-scope="option">
                <div class="car-colour">
                  <span class="colour-block" :style="{'background-image': option.style}"></span>
                  <span class="colour-label">{{ option.label }}</span>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3" v-if="typeof selectedVehicle._id !== 'undefined'?true:false">
          <b-form-group
            label="Status"
            :invalid-feedback="selectedVehicleErrors.status"
            :state="(typeof selectedVehicleErrors.status !== 'undefined') ? false : true"
          >
            <v-select
              placeholder="select status"
              v-model="vehicleStatusSelected"
              :options="vehicleStatuses"
              :state="(typeof selectedVehicleErrors.status !== 'undefined') ? false : null"
              :disabled="!editable"
            ></v-select>
          </b-form-group>
          
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group
            label="Number of passenger seats"
            :invalid-feedback="selectedVehicleErrors.carSeats"
            :state="(typeof selectedVehicleErrors.carSeats !== 'undefined') ? false : true"
          >
            <v-select
              placeholder="No. Seats"
              v-model="vehicleSeatsSelected"
              :options="vehicleNumberSeats"
              :disabled="(typeof selectedVehicle._id !== 'undefined') && !editable"
              :state="(typeof selectedVehicleErrors.carSeats !== 'undefined') ? false : null"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3" class="car-illustration">
          <div v-if="vehicleSize === 'xl'">
            <font-awesome-icon
              icon="xl-car"
              class="text-primary"
              :style="{'height': '80px!important'}"
            />
          </div>
          <div v-else>
            <font-awesome-icon
              icon="standard-car"
              class="text-primary"
              :style="{'height': '80px!important'}"
            />
          </div>
        </b-col>
        <b-col cols="6" sm="3" md="6">
          <b-form-group class="m-0" label="Comment" v-if="(selectedVehicle.status === 'inactive')">
            <b-form-textarea
                        v-model="selectedVehicle.comment"
                        id="textarea"
                        placeholder="Enter reason for inactive..."
                        rows="3"
                        max-rows="5"
                        :disabled="!editable && selectedVehicle.comment !== 'undefined'"
                     ></b-form-textarea>
                      </b-form-group>
        </b-col>
        <b-col cols="12" align="right" v-if="typeof selectedVehicle._id !== 'undefined'?true:false">
          <b-button  size="sm" variant="primary" @click="onEditClick" v-if="!editable && isEditAllow">Edit</b-button>
          <b-button  size="sm" @click="updateVehicle" v-if="(editable && isEditAllow )">Save</b-button> 
          <b-button class="ml-10" size="sm" variant="secondary" @click="closeModal">Close</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import moment from "moment";

export default {
  name: "vehiclesDetails",
  components: {},
  props: {
    driverId:String,
    driverCar:String,
    selectedVehicle: Object,
    createEvent: Boolean,
    createdVehicle: Function
  },
  computed: {
    vehicleNumberSeats() {
      let seats = [4, 6, 7, 8];
      return seats;
    }
  },
  data() {
    return {
      vehicleColor: "",
      carModelYear: [],
      vehicleMakes: [],
      vehicleModels: [],
      vehicleColours: [],
      vehicleSize: "standard",
      plateNumber: "",
      nickname: "",
      vehicleMakeSelected: null,
      vehicleModelSelected: null,
      vehicleYearSelected: null,
      vehicleColourSelected: null,
      vehicleSeatsSelected: 4,
      selectedVehicleErrors: {},
      updating: false,
      loadingDetails: true,
      hasVinNumber: false,
      vehicleStatusSelected:null,
      vehicleStatuses: [
        { label:"Awaiting Approval",value:"awaiting_approval"},
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" }
      ],
      isEditAllow:true, // always allowed
      editable:false
    };
  },
  watch: {
    createEvent(newVal) {
      if (newVal) {
        this.createVehicle();
      }
    },
    "selectedVehicle.plateNumber": function(newVal) {
      this.selectedVehicle.plateNumber = newVal.toUpperCase();
      // this.selectedVehicle.plateNumber = this.plateNumber;≥ß
    },
    nickname(newVal) {
      this.selectedVehicle.nickname = newVal;
    },
    async vehicleMakeSelected(newVal) {
      this.selectedVehicle.make = newVal !== null ? newVal.make_display : null;
      this.selectedVehicle.makeId = newVal !== null ? newVal.make_id : null;
      await this.getVehicleModel(this.selectedVehicle.makeId);
      this.loadingDetails = false;
      return newVal;
    },
    vehicleModelSelected(newVal) {
      this.selectedVehicle.model = newVal !== null ? newVal.model_name : null;
      this.selectedVehicle.modelId = newVal !== null ? newVal.model_id : null;
      return newVal;
    },
    vehicleYearSelected(newVal) {
      this.selectedVehicle.year = newVal;
      return newVal;
    },
    vehicleColourSelected(newVal) {
      if (newVal !== null && typeof newVal.label !== "undefined") {
        this.selectedVehicle.colour = newVal.label;
      }
      return newVal;
    },
    vehicleStatusSelected(newVal){
      if(newVal!==undefined && typeof newVal.label !== "undefined"){
        this.selectedVehicle.status=newVal.value;
      }
      return newVal;
    },
    vehicleSeatsSelected(newVal) {
      if (newVal > 4) {
        this.vehicleSize = "xl";
      } else if (newVal == null) {
        this.vehicleSeatsSelected = 4;
      } else {
        this.vehicleSize = "standard";
      }

      this.selectedVehicle.carSeats = newVal;
      return newVal;
    }
  },
  async created() {
    await this.getVehicleMake();
    await this.getVehicleColour();
    this.getYear();
    if (typeof this.selectedVehicle._id !== "undefined") {
      
      this.getVinNumber();
      // await this.getVehicleModel(this.selectedVehicle.makeId);
      this.matchKeys();
      // Allow editing vehicle regardless of status so tech doesnt have to do support work. - JJs
      // if(this.selectedVehicle.status !== "active"){
      //       this.isEditAllow=true;
      // }else{
      //       this.isEditAllow=false;
      // }
    } else {
      this.loadingDetails = false;
    }
    
  },
  methods: {
    getVinNumber() {
      // Check to see if thie vehicle has a VIN number.
      // Some vehicles were added before this feature. So might be empty.
      // Disable VIN if number is in there.
      if(typeof this.selectedVehicle.vinNumber !== "undefined" && this.selectedVehicle.vinNumber !== '') this.hasVinNumber = true;
    },
    matchKeys() {
      this.plateNumber = this.selectedVehicle.plateNumber;
      this.nickname = this.selectedVehicle.nickname;
      this.vehicleStatusSelected=(this.vehicleStatuses.filter(ob=>ob.value===this.selectedVehicle.status))[0] ;
      this.vehicleMakeSelected = {
        make_display: this.selectedVehicle.make,
        make_id: this.selectedVehicle.makeId
      };
   },
    findColorStyle(label) {
      for (let color of this.vehicleColours) {
        if (color.label === label) {
          return color.style;
        }
      }
    },
    formatDate(dateString) {
      return moment(dateString).format("DD/MM/YYYY");
    },
    async updateVehicle() {
      try {
        this.editable=false;
        this.updating = true;
        if(this.selectedVehicle.status==="active" && this.selectedVehicle.comment!=="")
        {
          this.selectedVehicle.comment="";
        }
        let savedVehicle=await shebahApi.api.drivers.vehicles.saveVehicle(
          this.driverId,
          this.selectedVehicle,
          this.selectedVehicle._id
        );
        this.getVinNumber();
        if (this.driverCar == this.selectedVehicle._id) {
          await shebahApi.api.drivers.updateDefaultVehicle(this.driverId,{
            carSeats: this.selectedVehicle.carSeats
          });
        }
        this.updating = false;
        this.selectedVehicleErrors = {};
          this.$emit("vehicleChange", savedVehicle);
      } catch (e) {
        this.updating = false;
        if (typeof e.response !== "undefined") {
          this.selectedVehicleErrors = e.response.data.error.collection;
        } else {
          console.error(e);
        }
      }
    },
    async getVehicleMake() {
      this.vehicleMakes = await shebahApi.api.drivers.lists.vehiclesMakes(this.driverId);
    },
    async getVehicleModel(makeId) {
      if (typeof makeId !== "undefined") {
        this.vehicleModels = await shebahApi.api.drivers.lists.vehiclesModels(this.driverId, makeId);

        setTimeout(() => {
          this.vehicleModelSelected = {
            model_name: this.selectedVehicle.model,
            model_id: this.selectedVehicle.model_id
          };

          let colorObj = {
            label: this.selectedVehicle.colour,
            style: this.findColorStyle(this.selectedVehicle.colour)
          };

          this.vehicleColourSelected = colorObj;
          this.vehicleYearSelected = this.selectedVehicle.year;
        }, 1);

        this.vehicleSeatsSelected = this.selectedVehicle.carSeats;
      } else {
        this.vehicleModels = [];
        this.vehicleModelSelected = null;
      }
    },
    async getVehicleColour() {
      this.vehicleColours = await shebahApi.api.drivers.lists.vehiclesColour(this.driverId);
    },
    getYear() {
      let currentYear = Number(moment().format("YYYY")) + 1;
      let startYear = currentYear - 60;
      let years = [];
      for (let i = startYear; i <= currentYear; i++) {
        years.push(String(i));
      }
      this.carModelYear = years.reverse();
    },
    async createVehicle() {
      try {
        let savedVehicle = await shebahApi.api.drivers.vehicles.saveVehicle(
          this.driverId,
          this.selectedVehicle
        );
        this.createdVehicle(savedVehicle);
      } catch (e) {
        if (typeof e.response !== "undefined") {
          this.selectedVehicleErrors = e.response.data.error.collection;
        } else {
          console.error(e);
        }
      }
    },
    closeModal(){
      this.$emit("closeCallback",{});
    },
    onEditClick(){
      this.editable=true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.car-illustration {
  height: 90px;
  svg {
    font-size: 30px;
  }
}
.car-colour {
  .colour-block {
    display: inline-block;
    width: 20px;
    height: 20px;
    float: left;
    -webkit-border-radius: 100%;
    border-radius: 100%;
  }
  .colour-label {
    display: inline-block;
    padding: 0 0 0 5px;
    float: left;
  }
  &::after {
    content: "";
    clear: both;
    display: table;
  }
}
</style>
